/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import "../../../assets/styles/custom-style.css";
import { useAuth } from "../../../auth";
import CloseButton from "../../../component/core/Buttons";
import {
  
  couponCreate,
  checkDuplicateCoupon,
} from "../core/_requests";
import { getCategory, getCuisine } from "../core/_requests";

import { useNavigate } from "react-router-dom";
import { UUID } from "crypto";
import ListCoupon from "./ListCoupon";

import { couponSchema } from "../core/Schema";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";


interface Cuisine {
  uuid: UUID;
  name: string;
}

interface Type {
  uuid: UUID;
  name: string;
}

interface Category {
  uuid: UUID;
  name: string;
}

interface CouponAdd {
  chefId: string | undefined;
  name: string;
  amount: string;
  limit: string;
  minimumOrderValue: string;
  usagePerUser: string;
  categoryId: string;
  cuisineId: string;
  startDate: string;
  endDate: string;
  couponType: string;
  createdBy: any;
  updatedBy: any;
}

const initialValues: CouponAdd = {
  chefId: "",
  name: "",
  amount: "",
  categoryId: "",
  cuisineId: "",
  limit: "",
  minimumOrderValue: "",
  usagePerUser: "",
  startDate: "",
  endDate: "",
  createdBy: "",
  updatedBy: "",
  couponType: "",
};

const AddCoupon = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [data, setData] = useState<CouponAdd>(initialValues);
  const [loading, setLoading] = useState(false);
  const [cuisine, setCuisine] = useState<Cuisine[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  const [cuisineId, setCuisineId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [Duplicate, setDuplicate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentDate] = useState(new Date());
  const chefId = currentUser?.uuid;
  const [placeholderText, setPlaceholderText] = useState("Enter coupon value");
  const inputs = useRef<Array<HTMLInputElement | HTMLSelectElement | null>>([]);


  const clickCancel = () => {
    navigate("/coupon");
  };

  const formik = useFormik<CouponAdd>({
    initialValues: data,
    enableReinitialize: true,
    validationSchema: couponSchema,
    onSubmit: async (values, { resetForm }) => {
      values.chefId = chefId;
      values.createdBy = currentUser?.chefId;
      // 🔥 Format the dates
      values.startDate = moment(values.startDate).format("YYYY-MM-DD HH:mm:ss");
      values.endDate = moment(values.endDate).format("YYYY-MM-DD HH:mm:ss");
      const updatedData = Object.assign({}, data, values);
      setLoading(true);
      couponCreate(updatedData).then((res) => {
        if (res?.status === true) {
          resetForm();
          setData(initialValues); // Reset data state to initial values
          navigate("/coupon/success", { replace: true });
          setLoading(false);
        } else {
          setLoading(false);
          setErrorMessage(res?.message);
        }
      });
    },
  });

  useEffect(() => {
    checkDuplicateCoupon(formik.values.name).then((response) => {
      if (response?.isDuplicate === true) {
        setDuplicate("Coupon name already exist");
      } else {
        setDuplicate("");
      }
    });
  }, [formik.values.name]);

  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate());

  useEffect(() => {
  const loadMasterData = async () => {
    try {
      const [cuisineRes, categoryRes] = await Promise.all([
        getCuisine(),
        getCategory(),
      ]);

      if (cuisineRes?.data?.data) {
        setCuisine(cuisineRes.data.data);
      }

      if (categoryRes?.data?.data) {
        setCategory(categoryRes.data.data);
      }
    } catch (error) {
      console.error("Failed to load cuisine/category", error);
    }
  };

  loadMasterData();
}, []);

  return (
    <>
      <section className="container-fluid addContainerFluid">
        <ListCoupon />
        <div className="overlay"></div>
        <div className="drawer small">
          <div className="title row">
            <h3 className="col-10 mb-0">Add New Coupon</h3>
            <div className="col-2 text-end mb-2">
              <button
                className="btn p-0 close d-inline-flex"
                onClick={clickCancel}
              >
                <i className="material-symbols-outlined">close</i>
              </button>
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Code
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.name && formik.errors.name,
                  },
                  {
                    "is-valid": formik.touched.name && !formik.errors.name,
                  }
                )}
                ref={(el) => {
                  inputs.current[3] = el;
                }}

                placeholder="Give a code to coupon"
                {...formik.getFieldProps(`name`)}
              />
              {formik.touched.name && formik.errors.name && (
                <div className="fv-help-block text-danger">
                  {formik.errors.name}
                </div>
              )}
              <span style={{ color: "red" }}>{Duplicate ? Duplicate : ""}</span>
            </div>
            {/**Begin:  coupon value */}
            <div className="row mb-12  mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Value
              </label>
              <div className="col-lg-6">
                <select
                  className="form-select form-select-solid orm-select-lg required"
                  {...formik.getFieldProps("couponType")}
                  ref={(el) => {
                    inputs.current[3] = el;
                  }}

                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    formik.handleChange(e);

                    if (selectedValue === "1") {
                      setPlaceholderText("Enter Percentage (%)");
                    } else if (selectedValue === "2") {
                      setPlaceholderText("Enter Amount ($)");
                    } else {
                      setPlaceholderText("Enter coupon value");
                    }
                  }}
                >
                  <option value="">Select Type...</option>
                  <option value={1}>Percentage</option>
                  <option value={2}>Amount ($)</option>
                </select>
                {formik.touched.couponType && formik.errors.couponType && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.couponType}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="capitalize-text form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                  placeholder={placeholderText}
                  ref={(el) => {
                    inputs.current[3] = el;
                  }}

                  {...formik.getFieldProps("amount")}
                />
                {formik.touched.amount && formik.errors.amount && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.amount}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/**End:  coupon value */}
            <div className="row  mb-3 mt-3 col-12">
              <label htmlFor="" className="form-label">
                Validity Perioder
              </label>
              <div className="col-lg-6 ">
             
                <DatePicker
                  selected={formik.values.startDate ? new Date(formik.values.startDate) : null}
                  onChange={(date) => formik.setFieldValue("startDate", date)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="MM-dd-yyyy HH:mm"
                  minDate={new Date()}
                  placeholderText="Enter coupon start date"
                  className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                />

                {formik.touched.startDate && formik.errors.startDate && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.startDate}
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-6">
               
                <DatePicker
                  selected={formik.values.endDate ? new Date(formik.values.endDate) : null}
                  onChange={(date) => formik.setFieldValue("endDate", date)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="MM-dd-yyyy HH:mm"
                  minDate={new Date()}
                  placeholderText="Enter coupon end date"
                  className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                />
                {formik.touched.endDate && formik.errors.endDate && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.endDate}
                    </div>
                  </div>
                )}
              </div>
            </div>
                        <div className="col-12 mb-3 mt-3">
  <label className="form-label">Cuisine</label>

  <select
    className={clsx("form-select", {
      "is-invalid": formik.touched.cuisineId && formik.errors.cuisineId,
    })}
    {...formik.getFieldProps("cuisineId")}
  >
    <option value="">Select Cuisine</option>

    {cuisine.map((item) => (
      <option key={item.uuid} value={item.uuid}>
        {item.name}
      </option>
    ))}
  </select>

  {formik.touched.cuisineId && formik.errors.cuisineId && (
    <div className="fv-help-block text-danger">
      {formik.errors.cuisineId}
    </div>
  )}
</div>
<div className="col-12 mb-3 mt-3">
  <label className="form-label">Category</label>

  <select
    className={clsx("form-select", {
      "is-invalid": formik.touched.categoryId && formik.errors.categoryId,
    })}
    {...formik.getFieldProps("categoryId")}
  >
    <option value="">Select Category</option>

    {category.map((item) => (
      <option key={item.uuid} value={item.uuid}>
        {item.name}
      </option>
    ))}
  </select>

  {formik.touched.categoryId && formik.errors.categoryId && (
    <div className="fv-help-block text-danger">
      {formik.errors.categoryId}
    </div>
  )}
</div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Coupon Limit
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid": formik.touched.limit && formik.errors.limit,
                  },
                  {
                    "is-valid": formik.touched.limit && !formik.errors.limit,
                  }
                )}
                placeholder="Give a limit to coupon"
                ref={(el) => {
                  inputs.current[3] = el;
                }}

                {...formik.getFieldProps(`limit`)}
              />
              {formik.touched.limit && formik.errors.limit && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-danger">
                    {formik.errors.limit}
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Minimum Order Value
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid":
                      formik.touched.minimumOrderValue &&
                      formik.errors.minimumOrderValue,
                  },
                  {
                    "is-valid":
                      formik.touched.minimumOrderValue &&
                      !formik.errors.minimumOrderValue,
                  }
                )}
                placeholder="Give a  minimum order value"
                ref={(el) => {
                  inputs.current[3] = el;
                }}

                {...formik.getFieldProps(`minimumOrderValue`)}
              />
              {formik.touched.minimumOrderValue &&
                formik.errors.minimumOrderValue && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block text-danger">
                      {formik.errors.minimumOrderValue}
                    </div>
                  </div>
                )}
            </div>
            <div className="col-12 mb-3 mt-3">
              <label htmlFor="" className="form-label">
                Usage Per User
              </label>
              <input
                type="text"
                className={clsx(
                  "form-control",
                  {
                    "is-invalid":
                      formik.touched.usagePerUser && formik.errors.usagePerUser,
                  },
                  {
                    "is-valid":
                      formik.touched.usagePerUser &&
                      !formik.errors.usagePerUser,
                  }
                )}
                placeholder="Give a  usage per user "
                ref={(el) => {
                  inputs.current[3] = el;
                }}

                {...formik.getFieldProps(`usagePerUser`)}
              />
              {formik.touched.usagePerUser && formik.errors.usagePerUser && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-danger">
                    {formik.errors.usagePerUser}
                  </div>
                </div>
              )}
            </div>



            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-4"></div>
                <div className="col-8 text-end">
                <CloseButton
                  onClose={clickCancel}
                    onSubmit={formik.handleSubmit}
                  loading={loading}
                   disabled={formik.isSubmitting || !formik.isValid }
             />
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default AddCoupon;
